import React from "react";
import clsx from "clsx";
import styles from "./Label.module.scss";

export interface LabelProps extends React.ComponentPropsWithoutRef<"label"> {
  required?: boolean;
  children: React.ReactNode;
  className?: string;
}

const Label = ({ required, children, className, ...props }: LabelProps) => {
  return (
    <label className={clsx(styles.label, className)} {...props}>
      {children}
      {required && <span className={styles.required}> *</span>}
    </label>
  );
};

export default Label;

